import { render, staticRenderFns } from "./aiComparison.vue?vue&type=template&id=4cd5fdc7&scoped=true"
import script from "./aiComparison.vue?vue&type=script&lang=js"
export * from "./aiComparison.vue?vue&type=script&lang=js"
import style0 from "./aiComparison.vue?vue&type=style&index=0&id=4cd5fdc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd5fdc7",
  null
  
)

export default component.exports